import React, { Component, useContext, useEffect, useState } from "react";
import "./SpsCommerceFilterTransactionsModal.scss";
import UserContext from "../../../../contexts/UserContext";
import SupplierContext from "../../../../contexts/SupplierContext";
import OwButton from "../../../shared/OwButton/OwButton";
import IErrorDTO from "../../../../models/DTO/IErrorDTO";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import ISpsCommerceFilterTransactionsDTO from "../../../../models/DTO/ISpsCommerceFilterTransactionsDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import ISpsCommerceOnFilterTransactionsDTO from "../../../../models/DTO/ISpsCommerceOnFilterTransactionsDTO";
import { Socket } from "socket.io-client";

type Props = {
    closeModalFn: () => void;
    socket: Socket;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
};

export const SpsCommerceFilterTransactionsModal: React.FC<Props> = (props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        props.socket.on(EndpointsEnum.SpsCommerceOnFilterTransactions, onFilterTransactions);
        props.socket.on(EndpointsEnum.Notify, onNotify);

        return () => {
            props.socket.removeListener(EndpointsEnum.SpsCommerceOnFilterTransactions, onFilterTransactions);
            props.socket.removeListener(EndpointsEnum.Notify, onNotify);
        };
    });

    const closeModal = () => {
        props.closeModalFn();
    };

    const onNotify = () => {
        setIsActive(false);
    };

    const startFilter = () => {
        const payload: ISpsCommerceFilterTransactionsDTO = {
            userGuid: userModel.guid,
            userToken: userModel.token,
            supplierGuid: supplierModel.guid,
        };

        props.socket.emit(EndpointsEnum.SpsCommerceFilterTransactions, payload);

        setIsActive(true);
    };

    const onFilterTransactions = (data: ISpsCommerceOnFilterTransactionsDTO) => {
        console.log(data);
        setIsActive(false);
    };

    return (
        <div className={"SpsCommerceFilterTransactionsModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-filter"} title={"sps_commerce_filter_transactions"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div></div>
                <div>
                    <OwButton title={"start"} fn={startFilter} active={isActive} disableOnActive={true} />
                </div>
            </div>
        </div>
    );
};
